import React, { useState, useEffect } from 'react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import myPDF from "./report1.pdf";
import fontTHSarabunNew from '../../../../THSarabunNew.ttf';
import fontkit from '@pdf-lib/fontkit';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
// import fs from 'fs';
import {
  formatDateTH,
  formatDateTHYYYY,
  formatTHMMM,
} from '../../../../common/DateUtils';
import { toThaiDigits, formatNumber } from '../../../../common/NumberUtils';
import data from '../EmploymentPage/PersonProperties';
import { drawImageOnPdf } from './drawSign';
//from R3Frame.js

//ต้นฉบับจาก R1v2.js, 23-03-14
function R3v2() {
  const [pdfUrl, setPdfUrl] = useState('');
  const [param1, setParam1] = useState('');
  const [employee, setEmployee] = useState('');
  const [loading, setLoading] = useState(false);
  const { user: currentUser } = useSelector((state) => state.auth);

  //หัวหน้ากองสรรหา
  const { hrChief } = data;
  const getEmployee = async (uid) => {
    console.log('--R3v2.js--getEmployee--1', hrChief);
    setLoading(true);
    try {
      const { data } = await axios.get('/api/cis/employee/uid', {
        params: { id: uid },
      });

      console.log('--R3v2.js--getEmployee--2');
      console.log(data);

      // ดึงลายเซ็นทั้ง 3 พร้อมกัน (parallel) เพื่อลดเวลารอ
      const [signData, hrSignData, hrChiefSignData] = await Promise.all([
        getSignature(data?.emp?.idCard),
        getSignature(data?.forReportAdded2?.hrEmpNo),
        getSignature(hrChief.empNo),
      ]);

      // แปลงเป็น base64 image URL
      const toImgUrl = (raw) => {
        if (!raw) return '';
        const buffer = Buffer.from(raw, 'base64');
        return `data:image/png;base64,${buffer.toString('base64')}`;
      };

      const signImgUrl = toImgUrl(signData);
      const hrSignImgUrl = toImgUrl(hrSignData);
      const hrChiefSignImgUrl = toImgUrl(hrChiefSignData);

      // set employee พร้อมกับ signature images ในครั้งเดียว
      setEmployee({
        ...data,
        signImg: signImgUrl,
        hrSignImg: hrSignImgUrl,
        hrChiefSignImg: hrChiefSignImgUrl,
      });
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getSignature = async (idCard) => {
    console.log('--R3v2.js--getSignature--1', idCard);
    try {
      const { data } = await axios.get(`/api/signupload/${idCard}`);
      console.log('--R3v2.js--getSignature--2', data);
      return data?.data;
    } catch (error) {
      console.log(error.response);
    }
  };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setTimeout(() => {
          console.log(res);
        }, 400);
      });
  };

  var BASE64_MARKER = ';base64,';

  function convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('id');
    console.log('--R1v2.js--uid--', uid);
    getEmployee(uid);
    // getDataFromAPI();
  }, []);

  useEffect(() => {
    const loadPdf = async () => {
      // const url = '/app/document3v3.pdf';
      const url = '/app/document3v4.pdf';
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer(),
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch(fontTHSarabunNew).then((res) =>
        res.arrayBuffer(),
      );
      const myFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      console.log('----R2v2---loadPdf----', employee?.emp?.firstName);

      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();

      //สัญญาฉบับนี้ทำที่ กฟผ.
      firstPage.drawText(`กฟผ.`, {
        x: 279,
        y: 792 - 143,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //โดย ชื่อ-นามสกุล
      if (employee?.empHead?.PS_TName) {
        const hName = employee.empHead.PS_TName;
        const hSurname = employee.empHead.PS_TLastName;
        const prefix = employee.empHead.PS_TPrefixName;
        const fullName = prefix + hName + ' ' + hSurname;
        firstPage.drawText(`${fullName}`, {
          x: 401,
          y: 792 - 162,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ตำแหน่ง
      if (employee?.empHead?.ORG_TLongName) {
        // let pName = employee.empHead.ORG_TLongName;
        const division = employee.empHead.ORG_TShortName;
        // if (division.substring(0, 1) == 'อ') pName = 'ผู้อำนวยการ' + pName;
        // const len = pName.length;
        let fontSize = 14;
        //ถ้ายาวมาก จะให้ font เล็กลง
        // if (len > 35) {
        // fontSize = 10;
        // }
        firstPage.drawText(`${division}`, {
          x: 180,
          y: 792 - 180,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ชื่อ - นามสกุล
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;
        // const fullName = fName + ' ' + lName;

        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const start = 110;
        const end = 261;
        const space = end - start;
        const nameLen = fullName.length;
        const rest = space - nameLen;
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(`${fullName}`, {
          x: 90 + restHalf - nameLen,
          y: 792 - 199,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อายุ
      if (!!employee?.emp?.birthdate) {
        const bd = employee.emp.birthdate;
        const birthdate = new Date(bd);
        const ageInMilliseconds = Date.now() - birthdate.getTime();
        const ageInYears = new Date(ageInMilliseconds).getFullYear() - 1970;
        // console.log(ageInYears);

        firstPage.drawText(`${ageInYears && toThaiDigits(ageInYears)}`, {
          x: 288,
          y: 792 - 200,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ที่อยู่ตามทะเบียนบ้าน
      const pAddr1 = employee?.emp?.homeAddress;
      firstPage.drawText(`${pAddr1 && toThaiDigits(pAddr1)}`, {
        x: 140,
        y: 792 - 212,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //ตำบล/แขวง
      if (!!employee?.emp?.homeTambolName) {
        const tambol = employee.emp.homeTambolName;
        firstPage.drawText(`${tambol}`, {
          x: 168,
          y: 792 - 237,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อำเภอ/เขต
      if (!!employee?.emp?.homeDistrictName) {
        const dist = employee.emp.homeDistrictName;
        firstPage.drawText(`${dist}`, {
          x: 315,
          y: 792 - 237,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //จังหวัด
      if (!!employee?.emp?.homeProvinceName) {
        const prov = employee.emp.homeProvinceName;
        firstPage.drawText(`${prov}`, {
          x: 443,
          y: 792 - 237,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //รหัสไปรษณีย์
      if (!!employee?.emp?.homePostalCode) {
        const post = employee.emp.homePostalCode;
        firstPage.drawText(`${post && toThaiDigits(post)}`, {
          x: 170,
          y: 792 - 256,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //โทรศัพท์
      if (!!employee?.emp?.mobileNo) {
        const mobile = employee.emp.mobileNo;
        firstPage.drawText(`${mobile && toThaiDigits(mobile)}`, {
          x: 288,
          y: 792 - 256,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ปฏิบัติในตำแหน่ง
      if (!!employee?.jobData?.position) {
        const jobPosition = employee.jobData.position;
        const jobLevel = employee.jobData.empLevel;
        const jobFullName =
          jobPosition + ' ระดับ ' + (jobLevel && toThaiDigits(jobLevel));
        firstPage.drawText(`${jobFullName}`, {
          x: 455,
          y: 792 - 256,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ฝ่าย
      if (!!employee?.forReportAdded2?.division) {
        let division = employee?.forReportAdded2?.division;
        firstPage.drawText(`${division}`, {
          x: 177,
          y: 792 - 293,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      } else {
        const d1 = employee?.empDivision?.d1;
        const d2 = employee?.empDivision?.d2;
        const d3 = employee?.empDivision?.d3;
        let division = d3;
        //ถ้าฝ่ายไม่มี เอาช่วย
        if (d3 == '-') division = d2;
        //ถ้าฝ่ายและช่วยไม่มีเอารอง
        if (d3 == '-' && d2 == '-') division = d1;
        firstPage.drawText(`${division}`, {
          x: 177,
          y: 792 - 293,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      // if (!!employee?.empDivision) {
      //   const d1 = employee.empDivision.d1;
      //   const d2 = employee.empDivision.d2;
      //   const d3 = employee.empDivision.d2;
      //   let division = d3;
      //   //ถ้าฝ่ายไม่มี เอาช่วย
      //   if (d3 == '-') division = d2;
      //   //ถ้าฝ่ายและช่วยไม่มีเอารอง
      //   if (d3 == '-' && d2 == '-') division = d1;
      //   firstPage.drawText(`${division}`, {
      //     x: 177,
      //     y: 792 - 293,
      //     size: 14,
      //     font: myFont,
      //     color: rgb(0, 0, 0.5),
      //   });
      // }

      //รหัสสังกัด
      if (employee?.forReportAdded2?.orgCode) {
        firstPage.drawText(
          employee.forReportAdded2.orgCode &&
            toThaiDigits(employee.forReportAdded2.orgCode),
          {
            x: 328,
            y: 792 - 293,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //กอง
      if (employee?.forReportAdded2?.empDepartment) {
        const dept = employee.forReportAdded2.empDepartment || '-';
        //จัดให้อยู่กึ่งกลาง
        const start = 416;
        const end = 521;
        const space = end - start;
        const deptLen = dept.length;
        const rest = space - deptLen * 8; // ประมาณ 8px ต่อตัวอักษร
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(`${dept && toThaiDigits(dept)}`, {
          x: start + restHalf,
          y: 518,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //แผนก
      if (employee?.forReportAdded2?.empSection) {
        const section = employee.forReportAdded2.empSection || '-';
        //จัดให้อยู่กึ่งกลาง
        const start = 297;
        const end = 395;
        const space = end - start;
        const sectionLen = section.length;
        const rest = space - sectionLen * 8; // ประมาณ 8px ต่อตัวอักษร
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(`${section && toThaiDigits(section)}`, {
          x: start + restHalf,
          y: 518,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      const secondPage = pages[1];
      //ลงชื่อ กฟผ.
      if (employee?.empHead?.PS_TName) {
        const hName = employee.empHead.PS_TName;
        const hSurname = employee.empHead.PS_TLastName;
        const prefix = employee.empHead.PS_TPrefixName;
        const fullName = prefix + hName + ' ' + hSurname;
        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const start = 180;
        const end = 287;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        secondPage.drawText(`${fullName}`, {
          x: finalX,
          y: 589,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      if (!!employee?.empHead?.ORG_TLongName) {
        //จัดให้อยู่กึ่งกลาง - ตำแหน่ง
        let pName = employee.empHead.ORG_TLongName;
        const division = employee.empHead.ORG_TShortName;
        if (division.substring(0, 1) == 'อ') pName = 'ผู้อำนวยการ' + pName;

        const start = 156;
        const end = 307;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(pName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;
        secondPage.drawText(`${pName}`, {
          x: finalX,
          y: 571,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ลงชื่อ ผู้ปฏิบัติงาน
      //ชื่อ - นามสกุล
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;

        const start = 361;
        const end = 467;
        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        secondPage.drawText(`${fullName}`, {
          x: finalX,
          y: 589,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ลายเซ็นผู้สมัคร
      if (!!employee?.signImg) {
        try {
          console.log(
            'Drawing signImg (ผู้สมัคร):',
            employee.signImg?.substring(0, 50),
          );
          const startX = 360;
          const startY = 792 - 185;
          const image = await pdfDoc.embedPng(employee.signImg);
          console.log('signImg embedded successfully');
          await drawImageOnPdf(image, secondPage, startX, startY);
          console.log('signImg drawn successfully');
        } catch (err) {
          console.error('err signature img (ผู้สมัคร):', err);
        }
      } else {
        console.log('No signImg available for ผู้สมัคร');
      }

      //เลขประจำตัว
      if (!!employee?.forReportAdded2?.empNo) {
        const empNo = employee.forReportAdded2.empNo;
        firstPage.drawText(`${empNo && toThaiDigits(empNo)}`, {
          x: 200,
          y: 792 - 274,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เมื่อวันที่
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        const signDate = new Date(sd);
        firstPage.drawText(
          `${signDate.getDate() && toThaiDigits(signDate.getDate())}`,
          {
            x: 412,
            y: 792 - 143,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //เมื่อวันที่ เดือน
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        firstPage.drawText(`${formatTHMMM(sd)}`, {
          x: 473,
          y: 792 - 143,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เมื่อวันที่ พ.ศ.
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        firstPage.drawText(
          `${formatDateTHYYYY(sd) && toThaiDigits(formatDateTHYYYY(sd))}`,
          {
            x: 135,
            y: 792 - 162,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //เข้าทำงานที่ กฟผ. วันที่
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        const signDate = new Date(sd);
        firstPage.drawText(
          `${signDate.getDate() && toThaiDigits(signDate.getDate())}`,
          {
            x: 149,
            y: 792 - 312,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //เข้าทำงานที่ กฟผ. เดือน
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        firstPage.drawText(`${formatTHMMM(sd)}`, {
          x: 223,
          y: 792 - 312,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เข้าทำงานที่ กฟผ. พ.ศ.
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        firstPage.drawText(
          `${formatDateTHYYYY(sd) && toThaiDigits(formatDateTHYYYY(sd))}`,
          {
            x: 314,
            y: 792 - 312,
            size: 14,
            font: myFont,
            color: rgb(0, 0, 0.5),
          },
        );
      }

      //พยาน hr
      if (!!employee?.forReportAdded2?.hrEmpName) {
        const hrEmpName = employee.forReportAdded2.hrEmpName;

        //จัดให้อยู่กึ่งกลาง
        const start = 362;
        const end = 467;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(hrEmpName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        secondPage.drawText(hrEmpName, {
          x: finalX,
          y: 514,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      //พยาน hr
      if (!!employee?.forReportAdded2?.hrEmpPosition) {
        let hrEmpPosition = employee.forReportAdded2.hrEmpPosition;

        // Decode HTML: แปลง <p>...</p> เป็นบรรทัดใหม่
        hrEmpPosition = hrEmpPosition
          .replace(/<p>/gi, '')
          .replace(/<\/p>/gi, '\n')
          .replace(/&nbsp;/g, ' ')
          .trim();

        // แยกบรรทัด
        const lines = hrEmpPosition.split('\n').filter((line) => line.trim());

        const start = 337;
        const end = 490;
        const fontSize = 13;
        const lineHeight = 14; // ระยะห่างระหว่างบรรทัด

        // วาดแต่ละบรรทัดโดยจัดกึ่งกลาง
        lines.forEach((line, index) => {
          const textWidth = myFont.widthOfTextAtSize(line, fontSize);
          const space = end - start;
          const centerX = start + space / 2;
          const finalX = centerX - textWidth / 2;

          secondPage.drawText(line, {
            x: finalX,
            y: 495 - index * lineHeight, // แต่ละบรรทัดลดลง
            size: fontSize,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });
        });
      }

      //ลายเซ็น HR
      if (!!employee?.hrSignImg) {
        try {
          console.log(
            'Drawing hrSignImg (HR):',
            employee.hrSignImg?.substring(0, 50),
          );
          const startX = 358;
          const startY = 533;
          const image = await pdfDoc.embedPng(employee.hrSignImg);
          console.log('hrSignImg embedded successfully');
          await drawImageOnPdf(image, secondPage, startX, startY);
          console.log('hrSignImg drawn successfully');
        } catch (err) {
          console.error('err hr signature img:', err);
        }
      } else {
        console.log('No hrSignImg available for HR');
      }

      //ลายเซ็นหัวหน้ากองสรรหา
      if (!!employee?.hrChiefSignImg) {
        try {
          console.log(
            'Drawing hrChiefSignImg (HR Chief):',
            employee.hrChiefSignImg?.substring(0, 50),
          );
          const startX = 8;
          const startY = 533;
          const image = await pdfDoc.embedPng(employee.hrChiefSignImg);
          console.log('hrChiefSignImg embedded successfully');
          await drawImageOnPdf(image, secondPage, startX, startY);
          console.log('hrChiefSignImg drawn successfully');
        } catch (err) {
          console.error('err hr chief signature img:', err);
        }
      } else {
        console.log('No hrChiefSignImg available for HR Chief');
      }

      if (hrChief?.empName) {
        const fullName = hrChief?.empName;
        const start = 183;
        const end = 287;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        secondPage.drawText(`${fullName}`, {
          x: finalX,
          y: 514,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      if (!!hrChief?.position) {
        //จัดให้อยู่กึ่งกลาง - ตำแหน่ง
        let pName = hrChief.position;
        const start = 156;
        const end = 307;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(pName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;
        secondPage.drawText(`${pName}`, {
          x: finalX,
          y: 495,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      // Set the stroke width to 100px

      const pdfBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfBytes], { type: 'application/pdf' }),
      );
      setPdfUrl(pdfUrl);

      // setPdfUrl("/app/document1.pdf");
      // setPdfUrl("https://pdf-lib.js.org/assets/with_update_sections.pdf");
    };
    loadPdf();
  }, [employee]);

  // https://dev.to/collegewap/fix-react-hook-useeffect-is-called-conditionally-25m5

  if (!currentUser) {
    return <Navigate to="/app/login" />;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      {pdfUrl && (
        <iframe src={pdfUrl} width="100%" height="800px" title="PDF Viewer" />
      )}
    </div>
  );
}

export default R3v2;
